<template>
  <div id="more" class="footer">

    <!-- Footer content -->
    <div class="container">

      <!-- Mission Statement -->
      <div class="mission-section">
        <h2 class="mission-statement">
          <span class="stardust-title">Stardust</span> makes transparent tools to give people control of their
          personal data on the web
        </h2>
      </div>

      <hr>

      <!-- Links Grid -->
      <div class="footer-grid">

        <!-- Community Column -->
        <div class="footer-column">
          <h3 class="footer-heading">Community</h3>
          <div class="footer-link-item">
            <a href="https://discord.gg/Ssh9faHbSu" class="footerLinks" target="_blank" rel="noopener noreferrer" aria-label="Join Stardust Discord channel">Discord</a>
          </div>
          <div class="footer-link-item">
            <a href="https://www.reddit.com/r/StardustForum/" class="footerLinks" target="_blank" rel="noopener noreferrer" aria-label="Visit Stardust Forum on Reddit">Reddit Forum</a>
          </div>
          <div class="footer-link-item">
            <a href="https://github.com/stardustnetwork" class="footerLinks" target="_blank" rel="noopener noreferrer" aria-label="View Stardust on GitHub">GitHub</a>
          </div>
        </div>

        <!-- Resources Column -->
        <div class="footer-column">
          <h3 class="footer-heading">Resources</h3>
          <div class="footer-link-item">
            <a href="/contribute" class="footerLinks" aria-label="Contribute to Stardust">Contribute</a>
          </div>
          <div class="footer-link-item">
            <a href="/policies/website-privacy-policy" class="footerLinks" aria-label="Read our Privacy Policy">Privacy Policy</a>
          </div>
          <div class="footer-link-item">
            <a href="/policies/website-cookie-policy" class="footerLinks" aria-label="Read our Cookie Policy">Cookie Policy</a>
          </div>
        </div>

        <!-- Contact Column -->
        <div class="footer-column">
          <h3 class="footer-heading">Contact</h3>
          <div class="footer-link-item">
            <a href="mailto:hey@strdst.org" class="footerLinks" aria-label="Email Stardust support">hey@strdst.org</a>
          </div>
        </div>

        <!-- Featured Column -->
        <div class="footer-column featured-column">
          <h3 class="footer-heading">Featured On</h3>
          <ProductHuntButton />
        </div>

      </div>
    </div>

    <!-- Copyright -->
    <p class="copyright">
      © {{ currentYear }} Lumela OÜ<br>
      Tallinn, Estonia
    </p>
  </div>
</template>

<script>
import ProductHuntButton from "./CookieCutter/ProductHuntButton.vue";

export default {
  name: "MoreSection",
  components: {
    ProductHuntButton
  },
  props: {
    msg: String,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.footer {
  padding: var(--spacing-3xl) var(--container-padding) var(--container-padding);
  background-color: var(--color-charcoal-mist-70);
  backdrop-filter: var(--blur-glassmorphism);
  filter: var(--shadow-card);
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.container {
  max-width: var(--container-max-width);
  margin: 0 auto;
}

/* Mission Statement */
.mission-section {
  text-align: center;
  margin-bottom: var(--spacing-2xl);
}

.mission-statement {
  font-size: clamp(20px, 3vw, 28px);
  line-height: 1.5;
  color: var(--color-pure-white);
  margin: 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

hr {
  border: 1px solid var(--color-border-subtle);
  border-radius: 5px;
  margin: var(--spacing-2xl) 0;
}

/* Footer Grid */
.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-2xl);
  margin-bottom: var(--spacing-2xl);
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-heading {
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-stardust-gold);
  margin: 0 0 var(--spacing-md) 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.footer-link-item {
  margin-bottom: var(--spacing-sm);
}

.footerLinks {
  color: var(--color-muted-white-90);
  text-decoration: none;
  font-weight: var(--font-weight-regular);
  font-size: 15px;
  transition: var(--transition-quick);
  display: inline-block;
}

.footerLinks:hover {
  color: var(--color-stardust-gold);
  transform: translateX(3px);
}

.footerLinks:focus-visible {
  outline: 2px solid var(--color-stardust-gold);
  outline-offset: 3px;
  border-radius: 3px;
}

/* Featured Column */
.featured-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Copyright */
.copyright {
  text-align: center;
  color: var(--color-muted-white);
  font-size: 14px;
  margin: var(--spacing-2xl) 0 0 0;
  padding-top: 30px;
  border-top: 1px solid var(--color-border-subtle);
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    padding: var(--spacing-2xl) var(--container-padding) var(--container-padding);
  }

  .mission-section {
    margin-bottom: 30px;
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 30px;
  }

  .copyright {
    margin-top: 30px;
    padding-top: 20px;
  }
}

@media (max-width: 500px) {
  .footer {
    padding: 30px var(--spacing-md) var(--container-padding);
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .featured-column {
    align-items: center;
  }
}
</style>
